import { take, tap, catchError } from "rxjs/operators";
import * as i0 from "@angular/core";
/* This class accepts requests (in observable form), puts them in a priority queue and runs one at a time.
*
*   Used to lazily preload data for caching.
* */
export class RequestManagerService {
    constructor() {
        this.priorityQueue = [];
        this.isWorking = false;
    }
    addToQueue(obj) {
        this.priorityQueue.push(obj);
        console.log(this.priorityQueue);
        this.isWorking || this.next(); //Bug 593: Net na inloggen laden de monitors niet
    }
    next() {
        if (!this.priorityQueue.length) {
            this.isWorking = false;
            return;
        }
        this.isWorking = true;
        this.priorityQueue = this.priorityQueue.sort((o1, o2) => o2.priority - o1.priority);
        this.consumeOne(this.priorityQueue.pop());
    }
    consumeOne(prio) {
        if (prio.name == "MonitorStatus") {
            console.log("first status");
        }
        prio.observable
            .pipe(take(1), tap(() => this.next()), catchError(e => { this.next(); throw e; }))
            .subscribe(prio.subscriptionFunc);
    }
}
RequestManagerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RequestManagerService_Factory() { return new RequestManagerService(); }, token: RequestManagerService, providedIn: "root" });
